import { createApp } from 'vue';
import App from './App.vue';
import router from "@/router/routers";
import '../public/assets/css/style.css';
import '../public/assets/js/script';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css';
import 'vue3-select/dist/vue3-select.css';
import '@fortawesome/fontawesome-free/css/all.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Toast from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import i18n from '../src/services/i18n';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import VueApexCharts from 'vue3-apexcharts';
import 'swiper/swiper-bundle.css';
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper'; // Import Autoplay module

// Add Autoplay module to Swiper
Swiper.use([Navigation, Pagination, Autoplay]);

import BootstrapVue3 from 'bootstrap-vue-3';
import Vue3Select from 'vue3-select';

const app = createApp(App);
app.component('v-select', Vue3Select);
app.use(router);
app.use(BootstrapVue3);
app.component('apexChart', VueApexCharts);
app.use(i18n);
app.component('LoadingOverlay', Loading);
app.use(Toast, {
    position: 'top-right',
    autoClose: 5000,
    draggable: true,
});

app.mount('#app');
